import { useProducts } from "library/hooks/useProducts";
import { FlowController } from "../FlowController/FlowController";
import { TitleBarWrapper } from "../Modal/ModalWrappers";
import { AccountType } from "./flowScreens/AccountType";
import { CreditCard } from "./flowScreens/CreditCard";
import { FatalError } from "./flowScreens/FatalError";
import { LinkingOTP } from "./flowScreens/LinkingOTP";
import { PersonalLoan } from "./flowScreens/PersonalLoan";
import { Success } from "./flowScreens/Success";

const WrappedComponent = ({ component: Component, titleProps, ...rest }) => (
  <TitleBarWrapper {...titleProps}>
    <Component {...rest} />
  </TitleBarWrapper>
);

function AccountLinkFlow({
  closeFunction,
  overlayRef = window,
  showTitleBar = false,
}) {
  const productsInfo = useProducts();

  const betweenScreens = () => {
    // overlayRef is an element, safe to reassign
    // eslint-disable-next-line no-param-reassign
    overlayRef.scrollTop = 0;
  };
  const params = {
    products: productsInfo.data ?? [],
    steps: [1, 2, 3],
    currentStep: 1,
    closeFunction,
  };
  const wrapperProps = { closeFunction, title: "Link an existing account" };

  const screens = showTitleBar
    ? {
        AccountType: (
          <WrappedComponent component={AccountType} titleProps={wrapperProps} />
        ),
        CreditCard: (
          <WrappedComponent component={CreditCard} titleProps={wrapperProps} />
        ),
        OTP: (
          <WrappedComponent component={LinkingOTP} titleProps={wrapperProps} />
        ),
        PersonalLoan: (
          <WrappedComponent
            component={PersonalLoan}
            titleProps={wrapperProps}
          />
        ),
        FatalError: (
          <WrappedComponent component={FatalError} titleProps={wrapperProps} />
        ),
        Success,
      }
    : {
        AccountType,
        CreditCard,
        OTP: LinkingOTP,
        PersonalLoan,
        FatalError,
        Success,
      };

  return (
    <FlowController
      screens={screens}
      initialScreen="AccountType"
      initialParams={params}
      betweenScreens={betweenScreens}
    />
  );
}

export { AccountLinkFlow };
